import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import ButtonFormFonts from './ButtonFormFont'
import ButtonFormStyle from './ButtonFormStyle'
import type { ButtonFormBrandType, ButtonBrandForms } from './buttonTypes'

const FORM_MAP: ButtonBrandForms = {
  [BrandFormEnum.STYLE]: ButtonFormStyle,
  ...ButtonFormFonts,
}

const ButtonFormBrand: ButtonFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(ButtonFormBrand) as typeof ButtonFormBrand
